var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("activity-center-bell", {
        attrs: { status: _vm.bellStatus, "badge-count": _vm.bellBadgeCount },
        on: { click: _vm.handleBellClick },
      }),
      _vm._v(" "),
      _c(
        "popover",
        {
          ref: "popover",
          staticClass: "activity-center-popover",
          attrs: { placement: "bottom" },
        },
        [
          _c(
            "div",
            {
              staticClass: "m-0 vertical-flex-container",
              attrs: { id: "activity-center-pane-container" },
            },
            [
              _vm.notificationPermission === "granted"
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "nav-tabs-wrapper bb-0 vertical-flex-auto sticky-top bg-white",
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "nav nav-tabs" },
                          _vm._l(_vm.tabs, function (ref) {
                            var name = ref.name
                            var label = ref.label
                            return _c(
                              "li",
                              {
                                key: "activity-center-" + name,
                                staticClass:
                                  "nav-item w-100 m-0 d-flex align-items-center justify-content-center clickable",
                                class: _vm.activeItem(name)
                                  ? "nav-item-active"
                                  : "",
                                attrs: { id: "activity-center-" + name },
                                on: {
                                  click: function ($event) {
                                    return _vm.setCurrentTab(name)
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "nav-link grey-text text-darken-3 px-2 py-0 my-2",
                                    class: _vm.linkClass(name),
                                    attrs: { "data-count": _vm.bellBadgeCount },
                                  },
                                  [_vm._v(_vm._s(label))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(_vm.currentTab + "-tab", {
                      tag: "component",
                      attrs: {
                        loading: false,
                        "badge-count": _vm.bellBadgeCount,
                        filters: _vm.filters,
                      },
                      on: { "filter-change": _vm.loadAllNotifications },
                    }),
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "inactive-notifications d-flex flex-column align-items-center justify-content-center w-100 h-100",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-bell-slash-o",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "text-light-gray w-75 mt-3 bold" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "notifications.messages.notificationsAreDisabled"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "text-light-gray bold text-separator",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.$t("global.words.or")
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            on: { click: _vm.handlePermissions },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "notifications.actions.allowNotifications"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "text-light-gray inactive-footer-text",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "notifications.messages.youCanDisableThem"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }